export function splitPathAndProperty(fullPath) {
    const lastSlashIndex = fullPath.lastIndexOf('/');
    if (lastSlashIndex === -1) {
        throw new Error(`Invalid path format: ${fullPath}`);
    }
    const path = fullPath.substring(0, lastSlashIndex);
    const property = fullPath.substring(lastSlashIndex + 1);
    return {
        path,
        property,
    };
}
// export function splitPathAndProperty(fullPath: string): {
//     path: string;
//     property: string;
// } {
//     const regex = /^(.*)\/([^\/]+)$/;
//     const matches = fullPath.match(regex);
//     if (!matches) {
//         throw new Error(`Invalid path format: ${fullPath}`);
//     }
//     return {
//         path: matches[1],
//         property: matches[2],
//     };
// }
export function getKeyframeData(keyframes, path, defaultValue = 0) {
    return keyframes[path] ? keyframes[path][0] : defaultValue;
}
export function getAnimationData(keyframes, path) {
    return keyframes[path] ? keyframes[path] : [];
}
export function extractTransformData(animationData) {
    const keys = Object.getOwnPropertyNames(animationData.keyframes);
    const data = {};
    const paths = [];
    for (let i = 0; i < keys.length; i++) {
        let { path, property } = splitPathAndProperty(keys[i]);
        if (!~paths.indexOf(path)) {
            data[path] = {};
            paths.push(path);
        }
    }
    const transformProps = [
        'm_LocalPosition',
        'm_LocalRotation',
        'm_LocalScale',
    ];
    const components = {
        m_LocalPosition: ['x', 'y', 'z'],
        m_LocalScale: ['x', 'y', 'z'],
        m_LocalRotation: ['x', 'y', 'z', 'w'],
    };
    const from = {};
    const to = {};
    for (let i = 0; i < paths.length; i++) {
        const fromPath = {};
        const toPath = {};
        transformProps.forEach((prop) => {
            const fromProp = {};
            const toProp = {};
            let skipTransform = true;
            components[prop].forEach((comp) => {
                const key = `${paths[i]}/${prop}.${comp}`;
                fromProp[comp] = getKeyframeData(animationData.keyframes, key);
                toProp[comp] = getAnimationData(animationData.keyframes, key);
                if (!toProp[comp].every((v) => v === fromProp[comp])) {
                    // not all values are the same, so we need to transform
                    // TK: This might give issues at some point with animations that
                    // are used to just set 1 value and not really animate.
                    skipTransform = false;
                }
            });
            if (skipTransform &&
                prop === 'm_LocalScale' &&
                fromProp['x'] === 0 &&
                fromProp['y'] === 0 &&
                fromProp['z'] === 0) {
                // It can happen that the scale is set to 0,0,0 in the animation when
                // exporting from Unity for example.
                // This will cause the object to disappear. We need to make sure that the
                // we don't set the scale if we skipTransform and the scale is 0,0,0.
                // So, skip setting the scale
            }
            else {
                fromPath[prop.split('_')[1].toLowerCase()] = fromProp;
                if (!skipTransform) {
                    toPath[prop.split('_')[1].toLowerCase()] = toProp;
                }
            }
        });
        from[paths[i]] = fromPath;
        to[paths[i]] = toPath;
    }
    return {
        from,
        to,
        paths,
        duration: animationData.duration,
        wrapMode: animationData.wrapMode,
        name: animationData.name,
        guid: animationData.guid,
    };
}
export function findByPath(obj, path) {
    const objName = path.splice(0, 1)[0];
    if (!objName) {
        return obj;
    }
    else {
        const o = obj.findByNameDirect(objName)[0];
        if (!o) {
            return null; // Object not found
        }
        return findByPath(o, path);
    }
}
//# sourceMappingURL=utils.js.map